/**
 * ConnectionProtocolEnum
 * An enumeration.
 */
export enum ConnectionProtocolEnum {
  SSL = 'SSL',
  TLS = 'TLS',
}